var StreamHandler = require("streamhandler");
var util = require("./lib/util.es6");


var SocketStreamHandler = function (host, ssl) {
    StreamHandler.call(this);
    if (ssl === undefined) {
        ssl = (window.location.protocol === 'https:');
    }
    this.protocol = ssl ? 'wss' : 'ws';
    this.setHost(host);
    this.socket = null;
    if (window.CHROME_EXTENSION_VERSION) {
        this.setQueryParam('chrome-ext', window.CHROME_EXTENSION_VERSION);
    }
    debug.log('WebSocket', 'construct', this.protocol);
};
SocketStreamHandler.CONNECTING = 0;
SocketStreamHandler.OPEN = 1;
SocketStreamHandler.CLOSING = 2;
SocketStreamHandler.CLOSED = 3;
SocketStreamHandler.socketID = 0;
SocketStreamHandler.prototype = util.inherit(StreamHandler, {
    setHost: function (host) {
        this.host = host;
    },
    getHandler: function () {
        return this.socket;
    },
    isOpen: function () {
        return this._getReadyState() == SocketStreamHandler.OPEN;
    },
    isConnecting: function () {
        return this._getReadyState() == SocketStreamHandler.CONNECTING;
    },
    isSocket: function () {
        return !!this.socket;
    },
    isClosing: function () {
        return this._getReadyState() == SocketStreamHandler.CLOSING;
    },
    connect: function () {
        var self = this;
        var host = this._getHost();
        debug.log('Websocket', 'connect');
        try {
            // Open WebSocket
            this.socket = new WebSocket(host);
            this.socket.socketID = ++SocketStreamHandler.socketID;
            debug.log('Websocket', 'created', this.socket, this.socket.socketID);
            var openTimeout = setTimeout(_.bind(function () {
                debug.group('stream timeout');
                debug.warn('WebSocket', 'timeout', this.socket, this.socket.socketID, '(readystate: ' + this.socket.readyState + ')');
                this.error();
                debug.groupEnd();
            }, this), 10000);
            this.socket.onopen = function socketOnOpen (event) {
                debug.log('WebSocket', 'open', this, this.socketID, event);
                self.trigger('connected');
                if (openTimeout) {
                    clearTimeout(openTimeout);
                    openTimeout = null;
                }
            };
            this.socket.onmessage = function socketOnMessage (event) {
                if (this !== self.socket) {
                    debug.warn('WebSocket', 'received onmessage for stale socket', this, this.socketID, event);
                    return;
                }
                self.reset();
                if (event.data) {
                    var message;
                    try {
                        message = self.parseJsonMessage(event.data);
                    } catch (exc) {
                        debug.warn('WebSocket', 'parse', exc, event.data, event);
                        message = {
                            error: true,
                            message: 'invalid json',
                            json: event.data
                        };
                    }
                    self.onMessage(message);
                }
            };
            this.socket.onclose = function socketOnClose (event) {
                debug.group('stream close');
                debug.log('WebSocket onclose', this, this.socketID, '(aborted: ' + this.aborted + ' / clean: ' + event.wasClean + ')', event);
                if (openTimeout) {
                    clearTimeout(openTimeout);
                    openTimeout = null;
                }
                if (this !== self.socket) {
                    // This can happen if we manually stopped the socket
                    debug.warn('WebSocket', 'received onclose for stale socket', this.socketID);
                } else {
                    if (!this.aborted) {
                        self.onError();
                    }
                    self.socket = null;
                    self.onDisconnect();
                }
                debug.groupEnd();
            };
            this.socket.onerror = function socketOnError (event) {
                debug.group('stream error');
                debug.warn('WebSocket', 'onerror', this, this.socketID, '(readystate: ' + this.readyState + ')', event, event.wasClean);
                if (openTimeout) {
                    clearTimeout(openTimeout);
                    openTimeout = null;
                }
                debug.groupEnd();
            };
        } catch (exc) {
            debug.group('stream connection error');
            debug.error('WebSocket failed', exc.message, exc.fileName + ' [line '+exc.lineNumber+']');
            this.onConnectionError();
            debug.groupEnd();
        }
    },
    close: function (error) {
        if (!this.isSocket()) {
            debug.warn('No websocket to close');
            this.onDisconnect();
            return;
        }
        if (this.isClosing()) {
            debug.warn('Websocket already closing', this.socket, this.socket.socketID);
            return;
        }
        debug.log('WebSocket', 'close', this.socket, this.socket.socketID, '(readystate: ' + this._getReadyState() + ')');
        if (!error) {
            this.socket.aborted = true;
        }

        this.socket.close();

        // This happens in onclose handler too, but sometimes there's a delay before that, so don't wait
        if (error) {
            this.onError();
        }
        this.socket = null;
        this.onDisconnect();
    },
    socketError: function (warning, type, data) {
        var error = {
            success: false,
            error: 'websocket',
            websocket_error: type,
            message: 'Offline'
        };
        if (data._reqid) {
            error._reqid = data._reqid;
            debug.warn('<- [' + data._reqid + ' SOCK ERROR: ' + type + ']', warning, data);
        } else {
            debug.warn('socket error', type, warning, data);
        }
        this.trigger('socketError', error);
        return;
    },
    send: function (data) {
        var text = JSON.stringify(data);
        var logLine = '-> [';
        if (data._reqid) {
            logLine += data._reqid + ' ';
        }
        logLine += 'SOCK';
        if (data._method) {
            logLine += ' ' + data._method;
        }
        logLine += ']';
        debug.log(logLine, text);
        if (!this.isSocket()) {
            return this.socketError('No websocket to send to', 'no_socket', data);
        }
        if (!this.isOpen()) {
            return this.socketError('Trying to send to a closed Websocket', 'socket_closed', data);
        }
        this.socket.send(text);
    },
    _getHost: function () {
        var host = this.protocol + '://' + this.host;
        return host + this.getQueryString();
    },
    _getUrl: function () {
        if (this.socket) {
            return this.socket.url;
        }
    },
    _getProtocol: function () {
        if (this.socket) {
            return this.socket.protocol;
        }
    },
    _getReadyState: function () {
        if (this.socket) {
            return this.socket.readyState;
        }
    },
    _getBufferedAmount: function () {
        if (this.socket) {
            return this.socket.bufferedAmount;
        }
    }
});


module.exports = SocketStreamHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/socketstreamhandler.js
// module id = O/fm
// module chunks = 1